import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { ApiError, ListagemProps } from '../../../services/tipos';
import LegendaOrigemExclusao from '../../legenda-origem/exclusao';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../../rxlib/components/table';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { obterQuantidadeParaPular, tratarErroApi } from '../../../rxlib/services/utilitarios';

function LegendaOrigemListagem(props: ListagemProps) {
    const [exclusao, setExclusao] = useState<boolean>(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [legendasOrigem, setLegendasOrigem] = useState<[{}]>([{}]);
    const [showExclusao, setShowExclusao] = useState<boolean>(false);
    const [quantidadeTotal, setQuantidadeTotal] = useState<number>(0);
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [idLegendaOrigem, setIdLegendaOrigem] = useState<string>('');

    const handleHide = () => setShowWarning(false);

    const handleHideExclusao = () => setShowExclusao(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Legendas origem', link: '' },
    ];

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Legenda', campo: 'Legenda', tipo: 'string' },
            { nome: 'Origem', campo: 'Origem', tipo: 'string' },
        ],
    }

    const quantidadeRegistrosPorPagina = 10;
    const quantidadeParaPular = obterQuantidadeParaPular(parseInt(props.match.params.pagina), quantidadeRegistrosPorPagina);

    const temPermissao = usuarioTemPermissao(token, 'legenda_origem_visualizar');
    const linkNovo = usuarioTemPermissao(token, 'legenda_origem_novo') ? '/legendaorigem/novo' : '';
    const linkEdicao = usuarioTemPermissao(token, 'legenda_origem_editar') ? '/legendaorigem/editar' : '';
    const handleExclusao = usuarioTemPermissao(token, 'legenda_origem_excluir') ? handleExcluir : undefined;

    useEffect(() => {
        if (temPermissao) {
            setCarregando(true);
            api.get(`/OData/LegendaOrigem?$count=true&$top=${quantidadeRegistrosPorPagina}&$skip=${quantidadeParaPular}`)
                .then(response => {
                    setTimeout(() => {
                        setQuantidadeTotal(response.data['@odata.count']);
                        setLegendasOrigem(response.data.value);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
        }
    }, [quantidadeParaPular, temPermissao, exclusao]);

    function handleExcluir(id: string) {
        setIdLegendaOrigem(id);
        setShowExclusao(true);
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <Listagem
                    campoId='Id'
                    linkNovo={linkNovo}
                    tipoBotaoAcao='button'
                    listagemDetalhe={false}
                    carregando={carregando}
                    linkEdicao={linkEdicao}
                    onExcluir={handleExclusao}
                    fonteDados={legendasOrigem}
                    linkListagem='/legendaorigem'
                    descricao='Listagem de legendas origem'
                    configuracoesTabela={configuracoesTabela}
                    quantidadeTotalRegistros={quantidadeTotal}
                    linkVisualizacao='/legendaorigem/visualizar'
                    paginaAtual={parseInt(props.match.params.pagina)}
                    quantidadeRegistrosPorPagina={quantidadeRegistrosPorPagina} />
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <LegendaOrigemExclusao
                    show={showExclusao}
                    tratarErro={tratarErro}
                    onExcluir={setExclusao}
                    onHide={handleHideExclusao}
                    idLegendaOrigem={idLegendaOrigem} />
            </RxlibLayout>
        </>
    );
}

export default LegendaOrigemListagem;